enum DocumentProjectAccessScope {
  ALL = "all",
  MANAGEMENT = "management",
  SELECTED = "selected",
  ADMIN = "admin",
}

export default DocumentProjectAccessScope;